import { Select } from "@radix-ui/themes";
import { useI18n, type Locale } from "@/i18n";

const LABELS: Record<Locale, string> = {
  sv: "Svenska",
  en: "English",
  fi: "Suomi",
};

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();

  return (
    <Select.Root value={locale} onValueChange={(value) => setLocale(value as Locale)}>
      <Select.Trigger aria-label={t("nav.language")} variant="ghost" color="gray" />
      <Select.Content>
        {(Object.keys(LABELS) as Locale[]).map((code) => (
          <Select.Item key={code} value={code}>
            {LABELS[code]}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
}
